'use client';
import { FC } from 'react';
import { ListChildComponentProps } from 'react-window';
import { Checkbox } from '@/components/ui';

const ListItem: FC<
  ListChildComponentProps<{
    options: Array<{ label: string; value: string }>;
    selectedFilters: string[];
    handleFilterChange: (value: string) => void;
  }>
> = ({ index, style, data: { options, selectedFilters, handleFilterChange } }) => {
  const option = options[index];

  return (
    <div
      style={style}
      key={index}
      className="flex w-full items-center pl-2"
      data-testid={`list-item__container-${index}`}
    >
      <Checkbox
        onChange={() => handleFilterChange(option.value)}
        isSelected={selectedFilters.includes(option.value)}
        data-testid={`list-item__checkbox-${index}`}
      >
        {option.label}
      </Checkbox>
    </div>
  );
};

export default ListItem;
